const WarningMessage = ({title}: {title: string}) => (
  <div className="flex w-fit gap-2 text-sm px-2 py-1 items-center bg-red-50 text-red-600">
    <i className="icon-warning-triangle text-lg" />
    <span>{title}</span>
  </div>
);

export default WarningMessage;
